import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import { CategoryList } from '../models/category.model'

@Injectable({
	providedIn: 'root',
})
export class StoreService {
	private treeDataSubject: BehaviorSubject<CategoryList[]> =
		new BehaviorSubject<CategoryList[]>([])
	public treeData$: Observable<CategoryList[]> =
		this.treeDataSubject.asObservable()

	constructor(private http: HttpClient) {}

	// brands
	getBrands(body: any) {
		return this.http.post(`${ApiEndPoint.getBrandsApi}`, body)
	}
	addBrand(body: any) {
		return this.http.post(`${ApiEndPoint.addBrandApi}`, body)
	}
	deleteBrand(id: any) {
		return this.http.delete(`${ApiEndPoint.deleteBrandApi}?id=${id}`)
	}
	updateBrandStatus(body: any) {
		return this.http.put(`${ApiEndPoint.updateBrandStatusApi}`, body)
	}

	ChangeBrandActivationStatus(id: any, isActive: boolean) {
		return this.http.post(
			`${ApiEndPoint.ChangeBrandActivationStatusApi}?id=${id}&isActive=${isActive}`,
			''
		)
	}

	brandIsNameArExistsBefore(nameAr: any) {
		return this.http.post(
			`${ApiEndPoint.brandIsNameArExistsBeforeApi}?nameAr=${nameAr}`,
			''
		)
	}
	brandIsNameEnExistsBefore(nameEn: any) {
		return this.http.post(
			`${ApiEndPoint.brandIsNameEnExistsBeforeApi}?nameEn=${nameEn}`,
			''
		)
	}
	getCities(countryId: number) {
		return this.http.get(`${ApiEndPoint.getCities}?countryId=${countryId}`)
	}

	// categories
	getCategories() {
		return this.http.get(`${ApiEndPoint.SearchAllCategoriesApi}`)
	}

	addCategory(body: any) {
		return this.http.post(`${ApiEndPoint.CreateProductCategoryApi}`, body)
	}
	deleteCategory(id: any) {
		return this.http.delete(`${ApiEndPoint.deleteProductCategoryApi}?id=${id}`)
	}
	updateCategoryStatus(body: any) {
		return this.http.put(`${ApiEndPoint.UpdateProductCategoryApi}`, body)
	}

	ChangeCategoryActivationStatus(id: any, isActive: boolean) {
		return this.http.post(
			`${ApiEndPoint.ChangeCategoryActivationStatusApi}?id=${id}&isActive=${isActive}`,
			''
		)
	}

	categoryIsNameArExistsBefore(nameAr: any) {
		return this.http.post(
			`${ApiEndPoint.categoryIsNameArExistsBeforeApi}?nameAr=${nameAr}`,
			''
		)
	}
	categoryNameEnExistsBefore(nameEn: any) {
		return this.http.post(
			`${ApiEndPoint.categoryIsNameEnExistsBeforeApi}?nameEn=${nameEn}`,
			''
		)
	}
	UploadCategoryImage(body: any) {
		return this.http.post(ApiEndPoint.UploadProductCategoryImageApi, body)
	}
	uploadBrandImage(body: any) {
		return this.http.post(ApiEndPoint.UploadProductBrandImageApi, body)
	}
	// order

	getOrders(body: any) {
		return this.http.post(`${ApiEndPoint.getOrderListApi}`, body)
	}

	getOrdersNewCount(body: any) {
		return this.http.post(`${ApiEndPoint.getOrderNewCountApi}`, body)
	}
	getOrderDetails(id: string) {
		return this.http.get(`${ApiEndPoint.getOrderDetailsApi}?id=${id}`)
	}
	changeOrderStatus(body: any) {
		return this.http.post(`${ApiEndPoint.changeOrderStatusApi}`, body)
	}

	getAllCities(body: any) {
		return this.http.post(ApiEndPoint.GetAllCitiesApi, body)
	}

	getAllAreaies(body: any) {
		return this.http.post(ApiEndPoint.GetAllAreasApi, body)
	}
	exportOrdersToExcel(body: any) {
		return this.http.post(ApiEndPoint.exportOrdersToExcelApi, body)
	}
}
